/* Presentation only. Native Horizon owns commerce, navigation and editor behavior. */
(() => {
  'use strict';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('kaizen-entered');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.06 });
  const observe = (root) => {
    root.querySelectorAll('.kaizen-paths, .kaizen-library-intro, .section-resource-list__header').forEach((el) => {
      if (el.dataset.kaizenObserved) return;
      el.dataset.kaizenObserved = 'true';
      el.classList.add('kaizen-reveal');
      observer.observe(el);
    });
  };
  observe(document);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) observe(event.target);
  });
  reduceMotion.addEventListener('change', (event) => {
    if (!event.matches) return;
    observer.disconnect();
    document.querySelectorAll('.kaizen-reveal').forEach((el) => el.classList.add('kaizen-entered'));
  });
})();
